import React from 'react';
import NewsroomItem from './NewsroomItem';

const NewsroomList: React.FunctionComponent<any> = ({data}) => {
  let newsList;
  newsList = data && data.length > 0 ? data.map((article: any, index: number) =>
    <NewsroomItem key={`new-item-${index}`} data={article} />
  ) : null;

  return (
    <>
      { data.length > 0 &&
        <div className="py-6 border-t border-black">
          <p className="block text-xl font-bold mb-4">From the Newsroom</p>
            {newsList}
        </div>
      }
    </>
  )
}

export default NewsroomList;